<template>
  <div v-if="player" class="player" :style="position">
    <!-- Talk Cloud -->
    <div v-if="message" class="talk-cloud">
      {{ message }}
    </div>

    <!-- Player name -->
    <div class="player-name" :class="playerClass">
      <span>
        {{ player.userName }}
        {{ player.toepPoints > 1 ? `(${player.toepPoints})` : '' }}
      </span>
      <div
        v-if="player.userName === currentPlayer && canPlay"
        class="loader-container"
      >
        <div
          v-if="canPlay"
          class="loader-bar"
          :style="{
            width: loaderWidth + '%',
            backgroundColor: loaderValue < 5 ? 'red' : 'green',
          }"
        ></div>
      </div>
    </div>

    <!-- Display cards -->
    <div class="player-cards">
      <!-- Back of cards -->
      <div
        class="back-cards"
        v-if="showBack"
        :class="{ dimmed: playerClass?.dimmed }"
      >
        <img
          v-for="n in roundsLeft"
          :key="n"
          class="card"
          :style="{
            position: 'absolute',
            left: `${(n - 1) * 1}rem`,
            zIndex: n,
          }"
          :src="require('@/assets/svg-cards/Card_back_01.svg')"
        />
      </div>
      <!-- Last card played -->
      <div class="card-played">
        <img
          v-if="cardPlayed"
          class="card"
          :src="getCardImage(cardPlayed)"
          :style="{
            opacity: player.folded ? 0.5 : 1,
            position: 'absolute',
            left: isCurrentPlayer || player.folded ? '0' : `${roundsLeft - 1}rem`,
          }"
        />
      </div>
      <!-- Open cards if checked vuileWas -->
      <div
        v-if="revealedCards && revealedCards.length > 0 && !player.folded"
        class="open-cards"
        :class="{ dimmed: playerClass?.dimmed }"
      >
        <img
          v-for="(card, n) in revealedCards"
          :key="n"
          class="card"
          :style="{
            position: 'absolute',
            left: `${n * 1}rem`,
          }"
          :src="getCardImage(card)"
        />
      </div>

      <!-- Placeholder -->
      <div class="placeholder">
        {{ isCurrentPlayer && userName === currentPlayer && canPlay ? 'Your turn!' : '' }}
      </div>
    </div>

    <!-- Toep buttons -->
    <ToepButtons
      :show-buttons="showButtons"
      :show-vuile-was-button="showVuileWasButton"
      :show-check-button="showCheckButton"
      :is-toeped="isToeped"
      :user-name="userName"
      :last-toeper="lastToeper"
      :would-reach-max="wouldReachMax"
      :toep-value="toepValue"
      :player="player"
      :special-round="specialRound"
      :max-points="maxPoints"
      :player-id="playerId"
      @toep="$emit('toep')"
      @call="$emit('call')"
      @fold="$emit('fold')"
      @vuileWas="$emit('vuileWas')"
      @playSpecialRound="$emit('playSpecialRound')"
      @checkVuileWas="$emit('checkVuileWas', $event)"
    />
  </div>
</template>

<script>
import ToepButtons from './ToepButtons.vue'

export default {
  name: 'PlayerCard',
  components: {
    ToepButtons,
  },
  props: {
    player: Object,
    playerId: String,
    isCurrentPlayer: Boolean,
    userName: String,
    currentPlayer: String,
    canPlay: Boolean,
    position: Object,
    playerClass: Object,
    message: String,
    loaderWidth: Number,
    loaderValue: Number,
    showBack: Boolean,
    roundsLeft: Number,
    cardPlayed: Object,
    revealedCards: Array,
    showButtons: Boolean,
    showVuileWasButton: Boolean,
    showCheckButton: Boolean,
    isToeped: Boolean,
    lastToeper: String,
    wouldReachMax: Boolean,
    toepValue: Number,
    specialRound: Boolean,
    maxPoints: Number,
  },
  methods: {
    getCardImage(card) {
      if (card.value === undefined || card.suit === undefined) {
        return require('@/assets/svg-cards/Card_back_01.svg')
      }

      const valueMap = {
        12: '10',
        11: '9',
        10: '8',
        9: '7',
        8: '6',
        7: '5',
        6: '4',
        5: '3',
        4: '2',
        3: 'ace',
        2: 'king',
        1: 'queen',
        0: 'jack',
      }

      const suitMap = {
        0: 'hearts',
        1: 'diamonds',
        2: 'clubs',
        3: 'spades',
      }

      const cardValue = valueMap[card.value]
      const cardSuit = suitMap[card.suit]

      if (!cardValue || !cardSuit) {
        console.error('Card mapping error:', card)
        return ''
      }

      try {
        return require(`@/assets/svg-cards/${cardValue}_of_${cardSuit}.svg`)
      } catch (error) {
        console.error('Card image not found:', card, error)
        return ''
      }
    },
  },
  emits: ['toep', 'call', 'fold', 'vuileWas', 'playSpecialRound', 'checkVuileWas'],
}
</script>

